import React from 'react'
import Alexas from '../images/Alexas.png'

const Banner = () => {
  return (
    <>
     <section className="hero hero-bg d-flex justify-content-center align-items-center">
               <div className="container">
                    <div className="row">

                        <div className="col-lg-6 col-md-10 col-12 d-flex flex-column justify-content-center align-items-center">
                              <div className="hero-text">

                                   <h1 className="text-white" data-aos="fade-up">You are welcome to our eDocs Platform !</h1>
                                   <h3 className="text-white" data-aos="fade-up">To download your ABC Rights form, please click on "Start Now !" </h3>

                                   <a href="#project" className="custom-btn btn-bg btn mt-3" data-aos="fade-up" data-aos-delay="100">Start Now!</a>

                                   <strong className="d-block py-3 pl-5 text-white" data-aos="fade-up" data-aos-delay="200"><i className="fa fa-envelope mr-2"></i> info@firstregistrarsnigeria.com</strong>
                              </div>
                        </div>

                        <div className="col-lg-6 col-12">
                          <div className="hero-image" data-aos="fade-up" data-aos-delay="300">

                            <img src={Alexas} className="img-fluid" alt="Alexas" />
                          </div>
                        </div>

                    </div>
               </div>
     </section>
    
    </>
  )
}

export default Banner